import { createGlobalStore } from 'hox';
import { useState } from 'react';

interface Status {
  tabIndex: number;
  submitSuccess: boolean | undefined;
}

const initTabStatus: Status = {
  tabIndex: 0,
  submitSuccess: undefined,
};

function useReportTabs() {
  const [tabStatus, setTabStatus] = useState<Status>(initTabStatus);

  return { tabStatus, setTabStatus };
}

export const [useReportTabsStore] = createGlobalStore(useReportTabs);
